import { IFormInputValue } from "../../../model/form/FormInputValue";
import { IFormQualifierAttribute } from "../../../model/form/FormQualifierAttribute";
import { AttributeFormConstants } from "../../../common/Constants";

export interface TFormInputValuePresentationModel {
  formAttributeId: number;
  recordOrderNumber: number;
  qualifierAttributeId: number;
  formSectionQualifierId: number;
  formQualifierId: number;
  valueB: string;
  valueC: string;
  valueD: Date;
  valueIdRef: string;
  valueN: number;
  valueRef: string;
  valueV: string;
  isRequiredFlagVisible: boolean;
  visible: boolean;
}

export interface IFormInputValuePresentationModel
  extends TFormInputValuePresentationModel {
  attribute: IFormQualifierAttribute;
  value: any;
}

export const typeVariableNameMap = {
  [AttributeFormConstants.TYPE_VALUES.CHAR]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_CHAR]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.READ_ONLY_REFERENCA]: "valueV",
  [AttributeFormConstants.TYPE_VALUES.BLOB]: "valueB",
  [AttributeFormConstants.TYPE_VALUES.CLOB]: "valueC",
  [AttributeFormConstants.TYPE_VALUES.DATE]: "valueD",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_DATE]: "valueD",
  [AttributeFormConstants.TYPE_VALUES.NUMBER]: "valueN",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_NUMBER]: "valueN",
  [AttributeFormConstants.TYPE_VALUES.REFERENCA]: "valueRef",
  [AttributeFormConstants.TYPE_VALUES.INITIAL_REFERENCA]: "valueRef",
  [AttributeFormConstants.TYPE_VALUES.REFERENCA_2]: "valueRef"
};

const isValueRequired = (
  data: IFormInputValue,
  isParentSectionRequired: boolean,
  qualifierRowsChanged: number[],
  requiredQualifiers: number[]
) => {
  let valueRequired: boolean = false;
  if (
    isParentSectionRequired &&
    qualifierRowsChanged.includes(data.recordOrderNumber) &&
    requiredQualifiers.includes(data.recordOrderNumber)
  ) {
    valueRequired = true;
  }
  return valueRequired;
};

const FormInputValuePresentationModel = (
  data: IFormInputValue,
  isParentSectionRequired: boolean,
  qualifierRowsChanged: number[],
  requiredQualifiers: number[]
): IFormInputValuePresentationModel => {
  let _isRequiredFlagVisible = isValueRequired(
    data,
    isParentSectionRequired,
    qualifierRowsChanged,
    requiredQualifiers
  );
  return {
    formAttributeId: data.formAttributeId,
    recordOrderNumber: data.recordOrderNumber,
    qualifierAttributeId: data.qualifierAttributeId,
    formSectionQualifierId: data.formSectionQualifierId,
    formQualifierId: data.formQualifierId,
    valueB: data.valueB,
    valueC: data.valueC,
    valueD: data.valueD,
    valueIdRef: data.valueIdRef,
    valueN: data.valueN,
    valueRef: data.valueRef,
    valueV: data.valueV,
    isRequiredFlagVisible: _isRequiredFlagVisible,
    attribute: data.attribute,
    value: data.value,
    visible: data.visible
  };
};

export default FormInputValuePresentationModel;
